import chalk from 'chalk'

export {chalk as default}
